<ng-container *ngIf="ctx" [ngSwitch]="mainService.getShopPortalLayoutKind(shopSoort.Catalogus)">
  <app-catalog-graphic-parts-boxed-layout *ngSwitchDefault [ctx]="ctx"></app-catalog-graphic-parts-boxed-layout>
  <app-catalog-graphic-parts-scroll-layout *ngSwitchCase="1" [ctx]="ctx"></app-catalog-graphic-parts-scroll-layout>
</ng-container>
